import React from 'react';
import { File, Save } from 'lucide-react';

// Type simplifié pour la configuration robots.txt
export interface RobotsConfig {
  content: string;
  active: boolean;
}

interface RobotsConfigSectionProps {
  config: RobotsConfig;
  onConfigChange: (config: RobotsConfig) => void;
  onSave: () => void;
}

/**
 * Composant simplifié pour la configuration du fichier robots.txt
 */
const RobotsTxtConfigSection: React.FC<RobotsConfigSectionProps> = ({
  config,
  onConfigChange,
  onSave
}) => {
  // Exemple de robots.txt par défaut
  const defaultRobotsTxt = `User-agent: *
Disallow: /mon-espace/
Disallow: /api/
Allow: /

Sitemap: https://example.com/sitemap.xml`;

  // Mettre à jour le contenu du robots.txt
  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onConfigChange({
      ...config,
      content: e.target.value
    });
  };
  
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <div className="flex items-center mb-4">
        <File className="mr-2 text-blue-600" size={24} />
        <h2 className="text-xl font-semibold text-gray-800">Gestion du fichier robots.txt</h2>
      </div>
      
      <div className="mb-4">
        <p className="text-sm text-gray-600 mb-2">
          Modifiez directement le contenu du fichier robots.txt ci-dessous. 
          <a href="https://developers.google.com/search/docs/crawling-indexing/robots/create-robots-txt" 
             target="_blank" 
             rel="noopener noreferrer"
             className="text-blue-600 hover:underline ml-1">
            En savoir plus sur la syntaxe
          </a>
        </p>
        
        <textarea
          value={config.content || defaultRobotsTxt}
          onChange={handleContentChange}
          className="w-full h-64 p-4 border rounded-md font-mono text-sm"
          placeholder="Entrez le contenu de votre fichier robots.txt"
        />
      </div>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="robotsActive"
            checked={config.active}
            onChange={(e) => onConfigChange({ ...config, active: e.target.checked })}
            className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 rounded"
          />
          <label htmlFor="robotsActive" className="text-gray-700">
            Activer le fichier robots.txt
          </label>
        </div>
        
        <button
          onClick={onSave}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          <Save size={16} className="inline mr-1" />
          Enregistrer le fichier robots.txt
        </button>
      </div>
    </div>
  );
};

export default RobotsTxtConfigSection;